
import React from 'react';
import { HeroSection } from '@/components/landing/HeroSection';
import { FeatureSection } from '@/components/landing/FeatureSection';
import { ProfessionalToolSection } from '@/components/landing/ProfessionalToolSection'; 
import { PainPointsSection } from '@/components/landing/PainPointsSection';
import { TestimonialSection } from '@/components/landing/TestimonialSection';
import { TrustSection } from '@/components/landing/TrustSection';
import { FAQSection } from '@/components/landing/FAQSection';
import { DashboardPreviewSection } from '@/components/landing/DashboardPreviewSection';
import { LifetimeDealCTA } from '@/components/landing/LifetimeDealCTA';
import { FounderSection } from '@/components/landing/FounderSection';
import { PricingSection } from '@/components/landing/PricingSection';
import { ClosingCTASection } from '@/components/landing/ClosingCTASection';
import { Footer } from '@/components/landing/Footer';
import { AppDownloadButtons } from '@/components/whatsapp-community/AppDownloadButtons';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-sky-50 text-gray-900">
      <HeroSection />
      <AppDownloadButtons />
      <ProfessionalToolSection />
      <PainPointsSection />
      <TrustSection />
      <DashboardPreviewSection />
      <FounderSection />
      <TestimonialSection />
      <FeatureSection />
      <PricingSection />
      <LifetimeDealCTA />
      <ClosingCTASection />
      <FAQSection />
      <Footer />
    </div>
  );
}
